module.exports = __webpack_public_path__ + "img/banner-kiki-pc.2648c2cc.png";